import api from './api';

export const getStudentSummaryAdmin = async (userId) => {
  if (!userId) throw new Error('userId is required');
  const { data } = await api.get(`/analytics/student/${userId}/summary`);
  return data;
};

export const getStudentProgressAdmin = async (userId) => {
  if (!userId) throw new Error('userId is required');
  const { data } = await api.get('/admin/lesson-reports/progress-summary', {
    params: { studentId: userId },
  });
  return data;
};

const analyticsService = {
  getStudentSummaryAdmin,
  getStudentProgressAdmin,
};

export default analyticsService;
